/**
 * @file    booleanResponseOptions
 * @scope   SHARED
 * @summary Normalises SimpleBoolean response options so their values are 'true'/'false'.
 * @consumes Response select options of a field.
 * @produces Select options whose value is the boolean literal expected by the query engine.
 * @sideEffects None.
 * @notes   SimpleBoolean responses carry numeric ids (1/2); the query engine expects
 *          true/false. Shared by every filter editor (field filters, partition filters).
 */
import { SelectOptions } from 'core-ui/MultipleSelectSortable/MultipleSelectSortable';

export const SIMPLE_BOOLEAN_TYPE = 'SimpleBoolean';

const BOOLEAN_LABEL_VALUES: Record<string, boolean> = {
  True: true,
  Yes: true,
  '1': true,
  False: false,
  No: false,
  '0': false,
};

export const toBooleanResponseOptions = (options: SelectOptions[]): SelectOptions[] =>
  options.map((option) => ({
    ...option,
    value: BOOLEAN_LABEL_VALUES[String(option.label)] ?? option.value,
  }));

/** Returns the options normalised for SimpleBoolean fields, untouched otherwise. */
export const resolveResponseOptions = (
  fieldTypeName: string | undefined,
  options: SelectOptions[]
): SelectOptions[] =>
  fieldTypeName === SIMPLE_BOOLEAN_TYPE ? toBooleanResponseOptions(options) : options;
